export default __webpack_public_path__ + "static/media/FAQ_13_1.5eebdba9.png";